import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE, getStoredLanguage } from './languagePreference'

import { siteCommonSv } from './translations/sv/siteCommon'
import { siteCoreSv } from './translations/sv/siteCore'
import { pagesOverviewSv } from './translations/sv/pagesOverview'
import { pagesNewsSv } from './translations/sv/pagesNews'
import { pagesIssuesSv } from './translations/sv/pagesIssues'
import { pagesCalendarSv } from './translations/sv/pagesCalendar'
import { chartsStatisticsSv, pagesStatisticsSv } from './translations/sv/pagesStatistics'
import { pagesCompaniesSv } from './translations/sv/pagesCompanies'
import { pagesWarrantsSv } from './translations/sv/pagesWarrants'
import { pagesConvertiblesSv } from './translations/sv/pagesConvertibles'
import { authTranslationsSv } from './translations/sv/authTranslations'
import { notesTranslationsSv } from './translations/sv/notesTranslations'
import { watchListsTranslationsSv } from './translations/sv/watchListsTranslations'
import { advisorsTranslationsSv } from './translations/sv/advisorsTranslations'
import { investorsTranslationsSv } from './translations/sv/investorsTranslations'
import { reportsTranslationsSv } from './translations/sv/reportsTranslations'
import { pageNotFoundTranslationsSv } from './translations/sv/pageNotFoundTranslations'
import { componentsTranslationsSv } from './translations/sv/componentsTranslations'
import { entitiesSv } from './translations/sv/entities'
import { chartsCommonSv } from './translations/sv/chartsCommon'

import { siteCommonEn } from './translations/en/siteCommon'
import { siteCoreEn } from './translations/en/siteCore'
import { pagesOverviewEn } from './translations/en/pagesOverview'
import { pagesNewsEn } from './translations/en/pagesNews'
import { pagesIssuesEn } from './translations/en/pagesIssues'
import { pagesCalendarEn } from './translations/en/pagesCalendar'
import { chartsStatisticsEn, pagesStatisticsEn } from './translations/en/pagesStatistics'
import { pagesCompaniesEn } from './translations/en/pagesCompanies'
import { pagesWarrantsEn } from './translations/en/pagesWarrants'
import { pagesConvertiblesEn } from './translations/en/pagesConvertibles'
import { authTranslationsEn } from './translations/en/authTranslations'
import { notesTranslationsEn } from './translations/en/notesTranslations'
import { watchListsTranslationsEn } from './translations/en/watchListsTranslations'
import { advisorsTranslationsEn } from './translations/en/advisorsTranslations'
import { investorsTranslationsEn } from './translations/en/investorsTranslations'
import { reportsTranslationsEn } from './translations/en/reportsTranslations'
import { pageNotFoundTranslationsEn } from './translations/en/pageNotFoundTranslations'
import { componentsTranslationsEn } from './translations/en/componentsTranslations'
import { entitiesEn } from './translations/en/entities'
import { chartsCommonEn } from './translations/en/chartsCommon'

const resources = {
    sv: {
        translation: {
            site: {
                ...siteCommonSv,
                ...siteCoreSv,
            },
            pages: {
                issues: pagesIssuesSv,
                overview: pagesOverviewSv,
                news: pagesNewsSv,
                auth: authTranslationsSv,
                notes: notesTranslationsSv,
                watchLists: watchListsTranslationsSv,
                advisors: advisorsTranslationsSv,
                investors: investorsTranslationsSv,
                reports: reportsTranslationsSv,
                pageNotFound: pageNotFoundTranslationsSv,
                calendar: pagesCalendarSv,
                statistics: pagesStatisticsSv,
                companies: pagesCompaniesSv,
                warrants: pagesWarrantsSv,
                convertibles: pagesConvertiblesSv,
            },
            components: componentsTranslationsSv,
            entities: entitiesSv,
            charts: {
                ...chartsCommonSv,
                ...chartsStatisticsSv,
            },
        },
    },
    en: {
        translation: {
            site: {
                ...siteCommonEn,
                ...siteCoreEn,
            },
            pages: {
                issues: pagesIssuesEn,
                overview: pagesOverviewEn,
                news: pagesNewsEn,
                auth: authTranslationsEn,
                notes: notesTranslationsEn,
                watchLists: watchListsTranslationsEn,
                advisors: advisorsTranslationsEn,
                investors: investorsTranslationsEn,
                reports: reportsTranslationsEn,
                pageNotFound: pageNotFoundTranslationsEn,
                calendar: pagesCalendarEn,
                statistics: pagesStatisticsEn,
                companies: pagesCompaniesEn,
                warrants: pagesWarrantsEn,
                convertibles: pagesConvertiblesEn,
            },
            components: componentsTranslationsEn,
            entities: entitiesEn,
            charts: {
                ...chartsCommonEn,
                ...chartsStatisticsEn,
            },
        },
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: getStoredLanguage() ?? DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
